const debounce = ( callback, wait ) => {
	let timeoutId = null;
	return ( ...args ) => {
		window.clearTimeout( timeoutId );
		timeoutId = window.setTimeout( () => {
			callback.apply( null, args );
		}, wait );
	};
}

const throttle = ( callback, timeFrame ) => {
	let lastTime = 0;
	return ( ...args ) => {
		let now = Date.now();
		if ( now - lastTime >= timeFrame ) {
			callback.apply( null, args );
			lastTime = now;
		}
	};
}

const loadJS = async function ( url, implementationCode, location ) {

	//url is URL of external file, implementationCode is the code
	//to be called from the file, location is the location to 
	//insert the <script> element

	var scriptTag = document.createElement( 'script' );
	scriptTag.src = url;

	scriptTag.onload = implementationCode;
	scriptTag.onreadystatechange = implementationCode;

	location.appendChild( scriptTag );
};
